import EnvUtil from '../util/EnvUtil'


class ThemeList
{
  // ---------------------------------------------------------------------------------------------------------
	// --	ThemeList
	// ---------------------------------------------------------------------------------------------------------

  constructor(){
    console.log('ThemeList')

    $('.themes-list__item >a').click(function(e){
      e.preventDefault()

      //ターゲット参照
      const tag = $(this).attr('href')
      const target = $(tag)

      //アニメーション
      const headerH = (EnvUtil.isSP())?80:100
      const position = target.offset().top - headerH
      $('body, html').animate({ scrollTop: position }, 1000, 'easeInOutQuart')
    })


  }
  
	// ---------------------------------------------------------------------------------------------------------
}

export default ThemeList